<div class="module-wrapper content-wrapper assessment-details" *ngIf="!isBacked">
  <mat-card>
    <mat-card-content>
      <div class="head-container">
        <div class="pageTitle">
          <h1>{{'assessment.heading' | translate}}</h1>
        </div>
      </div>
      <br>
      <button mat-flat-button class="btn-warn" matTooltipPosition="right"
        matTooltip="{{'assessment.assessmentDetails.backToolTip' | translate}}" (click)="back()">{{'assessment.assessmentDetails.back' | translate}}
      </button>
      <br><br>

      <div class="patient-details">
        <div class="patient-name"><strong>{{'assessment.assessmentDetails.patientName' | translate}}: {{headerData?.patientName}}</strong></div>
        <div>{{'assessment.assessmentDetails.patientPhone' | translate}}: {{headerData?.countryCode}}{{headerData?.phone}} </div>
        <div *ngIf="headerData?.reasonofvisit">{{'assessment.assessmentDetails.visit' | translate}}: {{headerData?.reasonofvisit}} </div>
        <div>{{'assessment.assessmentDetails.assessmentDate' | translate}}: {{headerData?.assessmentStartDate}} </div>
      </div>

      <br><br>
      <div class="input-container">
        <div class="input-fields-wrapper">
          <div class="input-wrapper invalid">
            <select aria-placeholder="Status" [(ngModel)]="assessmentName" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="" selected>{{'assessment.assessmentDetails.assName' | translate}}</option>
              <option *ngFor="let sname of AssessmentDetails" [value]="sname.assessmentName">{{sname.assessmentName}}</option>
            </select>
          </div>
          <div class="input-wrapper invalid">
            <select aria-placeholder="Status" [(ngModel)]="assessmentStatus" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="0" selected>{{'assessment.assessmentDetails.assStatus' | translate}}</option>
              <option *ngFor="let s of assessmentStatusList" [value]="s.id">{{s.title}}</option>
            </select>
          </div>
          <div class="input-wrapper">
            <select aria-placeholder="Status" [(ngModel)]="assessmentType" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="0" selected>{{'assessment.assessmentDetails.assType' | translate}}</option>
              <option *ngFor="let s of assessmentTypeList" [value]="s.id">{{s.title}}</option>
            </select>
          </div>

          <div class="btn-wrapper">
            <button mat-flat-button class="btn-primary" (click)="searchFilter()" aria-label="Search">{{'assessment.patientList.btnSearch' | translate}}</button>
            <button mat-flat-button class="btn-flat" (click)="resetFilter()" aria-label="Reset">{{'assessment.patientList.btnReset' | translate}}</button>
          </div>
        </div>
      </div>

      <div *ngIf="isDatanotFound" class="data-not-found-container table-container">
        <span>{{'assessment.assessmentDetails.errMsg1' | translate}}</span>
      </div>
      <div class="table-container d-none" [class.d-block]="dataSource" *ngIf="!isDatanotFound">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="Assessmentname">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.assessmentDetails.column1' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.assessmentName}}</td>
          </ng-container>

          <ng-container matColumnDef="Assessmentstatus">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.assessmentDetails.column3' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.assessmentStatus}}</td>
          </ng-container>

          <ng-container matColumnDef="Assessmenttype">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.assessmentDetails.column2' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.assessmentType}}</td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.assessmentDetails.column4' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button [ngClass]="{'disableIcon': ((A1AssessmentStarted != AssessmentStatusIds.completed && row.scheduleCode != scheduleCodeEnum.A1) || row.assessmentStatusId == AssessmentStatusIds.inProgress || (row.assessmentStatusId == AssessmentStatusIds.completed))}"
              [disabled]="((A1AssessmentStarted != AssessmentStatusIds.completed && row.scheduleCode != scheduleCodeEnum.A1) || row.assessmentStatusId == AssessmentStatusIds.inProgress || (row.assessmentStatusId == AssessmentStatusIds.completed))" (click)="onStartAssessment(row)" matTooltip="{{'assessment.assessmentDetails.toolTip.startAssessment' | translate}}"
                class="play-icon">
                <mat-icon style="margin-top: 4px;">play_arrow</mat-icon>
              </button>

              <button mat-icon-button [ngClass]="{'disableIcon': row.assessmentStatusId == AssessmentStatusIds.notStarted || row.assessmentStatusId == AssessmentStatusIds.completed}"
              [disabled]="row.assessmentStatusId == AssessmentStatusIds.notStarted || row.assessmentStatusId == AssessmentStatusIds.completed" (click)="onResumeAssessment(row)" matTooltip="{{'assessment.assessmentDetails.toolTip.resume' | translate}}"
                class="pause-icon">
                <mat-icon>eject</mat-icon>
              </button>

              <button mat-icon-button *ngIf="row.assessmentTypeId == assessmentTypeIdEnum.patientAssisted" [ngClass]="{'disableIcon': ((A1AssessmentStarted != AssessmentStatusIds.completed && row.scheduleCode != scheduleCodeEnum.A1) || row.assessmentStatusId == AssessmentStatusIds.inProgress || (row.assessmentStatusId == AssessmentStatusIds.completed))}"
                [disabled]="((A1AssessmentStarted != AssessmentStatusIds.completed && row.scheduleCode != scheduleCodeEnum.A1) || row.assessmentStatusId == AssessmentStatusIds.inProgress || (row.assessmentStatusId == AssessmentStatusIds.completed))" (click)="onResendSMS(row)" matTooltip="{{'assessment.patientList.toolTip.resendSMS' | translate}}">
                <mat-icon> mail_outline</mat-icon>
              </button>

              <button mat-icon-button [ngClass]="{'disableIcon': row.assessmentStatusId == AssessmentStatusIds.notStarted || row.assessmentStatusId == AssessmentStatusIds.inProgress}"
              [disabled]="row.assessmentStatusId == AssessmentStatusIds.notStarted || row.assessmentStatusId == AssessmentStatusIds.inProgress" (click)="onViewReport(row)" matTooltip="{{'assessment.assessmentDetails.toolTip.viewReport' | translate}}"
              class="file-icon">
                <!-- <mat-icon>file_copy</mat-icon> -->
                <i class="fa fa-file-text-o" style="margin-top: 4px;" aria-hidden="true"></i>
              </button>

              <button mat-icon-button [ngClass]="{'disableIcon': row.assessmentStatusId == AssessmentStatusIds.notStarted || row.assessmentStatusId == AssessmentStatusIds.inProgress}"
              [disabled]="row.assessmentStatusId == AssessmentStatusIds.notStarted || row.assessmentStatusId == AssessmentStatusIds.inProgress" (click)="onDownloadReport(row)" matTooltip="{{'assessment.assessmentDetails.toolTip.downloadReport' | translate}}">
                <mat-icon style="margin-top: -2px;">save_alt</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div class="patient-paginator d-none" [class.d-block]="dataSource" *ngIf="!isDatanotFound">
        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- <app-detailed-test-report *ngIf="isDetailedTestReport" [patientData]="headerData" [selectedAssessmentData]="selectedAssessmentData"></app-detailed-test-report> -->

<app-patient-landing *ngIf="isBacked"></app-patient-landing>
<!-- ViewReport PDF section  -->
<div class="print-data">
  <div class="logos">
    <img *ngIf="configService.themeConfig.ImgUrl" [src]="configService.themeConfig.ImgUrl" alt="" width="180">

    <!-- <img *ngIf="configService.themeConfig.svaslogoUrl" [src]="configService.themeConfig.svaslogoUrl" alt="" width="150"> -->
  </div>
  <div class="header">
    <div class="patient-details">
      <div class="patient-name"><strong>{{'reports.detailedTestReport.patientName' | translate}}: {{headerData?.patientName}} </strong></div>
      <div>{{'reports.detailedTestReport.assessmentName' | translate}}: {{reportAssessmentName}} </div>
      <div>{{'reports.detailedTestReport.Score' | translate}}: {{totalScore}} </div>
      <div>{{'reports.detailedTestReport.Inference' | translate}}: <span [innerHtml]="testResult"></span></div>
    </div>
    <span class="spacer"></span>
  </div>

  <br>
  <div *ngIf="testDetails.length == 0" class="data-not-found-container table-container">
    <span>{{'reports.detailedTestReport.errMsg1' | translate}}</span>
  </div>

  <div class="table-container" *ngIf="testDetails.length">
    <table mat-table [dataSource]="printdataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="Question">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'reports.detailedTestReport.column1' | translate}}</th>
        <td mat-cell *matCellDef="let row; let i = index" [attr.rowspan]="getRowSpan('questionId', i)" [style.display]="getRowSpan('questionId', i) ? '' : 'none'"><span [innerHtml]="sanitizer.bypassSecurityTrustHtml(row?.question)"></span></td>
      </ng-container>

      <ng-container matColumnDef="options" *ngIf="optionsColShown">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'reports.detailedTestReport.column2' | translate}}</th>
        <td mat-cell *matCellDef="let row" [ngStyle]="{'background-color': (row.questionSubtypeId == '9') ? 'lightgray' : ''}">
          <span *ngIf="row.questionSubtypeId != '9'" [innerHtml]="sanitizer.bypassSecurityTrustHtml(row?.answers)"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="patientResponse">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'reports.detailedTestReport.column3' | translate}}</th>
        <td mat-cell *matCellDef="let row; let i = index">
          <span *ngIf="row.selected == 'True' && row.questionSubtypeId != '9'"><i class="fa fa-check" aria-hidden="true"></i></span>
          <span *ngIf="row.questionSubtypeId == '9'" [innerHtml]="sanitizer.bypassSecurityTrustHtml(row?.answers)"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="score"  *ngIf="scoreColShown">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'reports.detailedTestReport.column4' | translate}}</th>
        <td mat-cell *matCellDef="let row; let i = index">{{row.score}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="reportDisplayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: reportDisplayedColumns;"></tr>
    </table>
  </div>
  <br>
  <div class="diagnosis" *ngIf="!hideDiagnosis">
    <div><strong>{{'reports.detailedTestReport.Interpretation' | translate}}:</strong></div>
    <br>
    <div [innerHtml]="interpretationValue"></div>
    <br><br>
  </div>
</div>
